module.exports = __webpack_public_path__ + "static/media/yandex-device-tablet.0948308a.png";